import React from 'react';
import { main as setUpShareBar } from './projectPageShareBarMain.js';
import { main as setUpRecommendations } from './projectRecommendationsMain.js';
import { main as setUpFullyFundedProjectCallToAction } from './fullyFundedProjectCallToActionMain.js';
import { main as setUpReplacements } from './resourceReplacementsMain.js';
import { main as givingSetup } from './multiProjectGiving.js';
import { main as setUpAddToProjectFavorites } from './addToProjectFavoritesMain.js';
import { main as setUpAddToChallenge } from './addToChallengeMain.js';
import { main as setUpEmailSignup } from './emailSignupMain.js';

// A couple of features within the project page use React. They don't fit into
// a single React tree or anything, so they *can* be implemented as separate
// scripts. But I feel more comfortable with having a single top-level main function.
$(() => {
    setUpFullyFundedProjectCallToAction();
    setUpShareBar();
    setUpRecommendations();
    setUpReplacements();
    givingSetup();
    setUpAddToProjectFavorites();
    setUpAddToChallenge();
    setUpEmailSignup();
});
